import React, { useState, useEffect } from 'react';
import { db, collection, getDocs, query } from '../firebase';
import { Link } from 'react-router-dom';
import { List } from './common';
import Layout from './layout';

function Structured() {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, "structured"));
      const querySnapshot = await getDocs(q);
      setDocs(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };
    fetchData();
  }, []);

  

  return (
    <Layout>
      <Link to="/structured/new">New Structured Data</Link>
      <List>
        {docs.map((doc) => (
          <li key={doc.id}><Link to={`/structured/${doc.id}`}>{doc.name}</Link></li>
        ))}
      </List>
    </Layout>
  );
}

export default Structured;
